import { memo, useCallback } from "react";

import { Checkbox } from "@snapchat/snap-design-system";

import { LensTag, Visible } from "../../common/components";
import { formatMediumDateTime } from "../../common/formatters";
import { ItemCard, ItemName } from "../../common/styles";
import { checkboxStyle } from "../../common/styles/Checkbox.styles";
import { Flexbox } from "../../core/components";
import { type GroupsGridItemModel } from "../grid/model";

interface GroupsListItemProps {
    group: GroupsGridItemModel;
    isSelected: boolean;
    isNew: boolean;
    toggleSelection: (group: GroupsGridItemModel) => void;
}

export const GroupsListItem = memo<GroupsListItemProps>(({ group, toggleSelection, isSelected, isNew }) => {
    const selectGroup = useCallback(() => {
        toggleSelection(group);
    }, [group, toggleSelection]);

    const { name, id, lastUpdated } = group;

    return (
        <div data-testid="group-list-item">
            <ItemCard justifyContent="space-between" alignItems="center" onClick={selectGroup}>
                <Flexbox flexDirection="column">
                    <Flexbox alignItems="baseline">
                        <ItemName>{name}</ItemName>
                        <Visible when={isNew}>
                            <LensTag status="info">New</LensTag>
                        </Visible>
                    </Flexbox>
                    <span>
                        Last Updated:{" "}
                        <span data-testid="group-list-item-date">{formatMediumDateTime(lastUpdated as Date)}</span>
                    </span>
                    <span>
                        ID: <span data-testid="group-list-item-id">{id}</span>
                    </span>
                </Flexbox>
                <Checkbox data-testid="select-group" value={isSelected} checkboxClassName={checkboxStyle} />
            </ItemCard>
        </div>
    );
});
